export { default } from './TagAutocomplete'
export type { Tag, TagAutocompleteProps } from './TagAutocomplete.interface'
